module.exports = __webpack_public_path__ + "static/media/lamina17actividad.720fbc7d.png";